import { render, staticRenderFns } from "./TableLoadItemComponent.vue?vue&type=template&id=3143b444&"
import script from "./TableLoadItemComponent.vue?vue&type=script&lang=js&"
export * from "./TableLoadItemComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports